const module = { name: 'Fandango', exports: {} }; const exports = module.exports;

window.Fandango = window.Fandango ?? {};
window.Fandango.account = window.Fandango.account || {};
window.Fandango.analyticsData = window.Fandango.analyticsData || {};
window.Fandango.context = window.Fandango.context || {};
window.Fandango.dtmData = window.Fandango.dtmData || {};
window.Fandango.featureFlags = window.Fandango.featureFlags || {};
window.Fandango.freeTicketMovieIds = window.Fandango.freeTicketMovieIds || {};
window.Fandango.fwPlayer = window.Fandango.fwPlayer || {};
window.Fandango.globalTooltip = window.Fandango.globalTooltip || {};
window.Fandango.jwPlayerData = window.Fandango.jwPlayerData || {};
window.Fandango.logInUrls = window.Fandango.logInUrls || {};
window.Fandango.movieDetails = window.Fandango.movieDetails || {};
window.Fandango.movieReviews = window.Fandango.movieReviews || {};
window.Fandango.nativeDevice = window.Fandango.nativeDevice || {};
window.Fandango.pageDetails = window.Fandango.pageDetails || {};
window.Fandango.seatMapData = window.Fandango.seatMapData || {};
window.Fandango.showtimeData = window.Fandango.showtimeData || {};
window.Fandango.spotlight = window.Fandango.spotlight || {};
window.Fandango.templates = window.Fandango.templates || {};
window.Fandango.theater = window.Fandango.theater || {};
module.exports = window.Fandango;
module.exports.default = window.Fandango;
export default module.exports;